import useFetch from "../../global/hooks/useFetch";

export const useSourceAssets = (sourceId) => {
  const {
    data: assets,
    loading,
    error,
  } = useFetch(`/sources/${sourceId}/assets/`);

  return {
    assets: assets || [],
    loading,
    error,
  };
};
